import { memo } from 'react';
import { DataTableSkeleton } from '../components/DataTable';
import { USERS_COLUMNS, USERS_TABLE_MIN_WIDTH } from './UsersTable';

export const UsersTableSkeleton = memo(function UsersTableSkeleton() {
  return <DataTableSkeleton columns={USERS_COLUMNS} rows={5} minWidth={USERS_TABLE_MIN_WIDTH} />;
});

export default UsersTableSkeleton;
